// Zadání kódu pracoviště (jednorázově při instalaci / po změně kódu adminem).
// „Noční kokpit": wordmark + jedno velké skleněné pole + zlaté CTA. Pole i
// tlačítko sedí NAHOŘE pod logem — zespodu se vyroluje systémová klávesnice
// a na „Připojit se" musí jít ťuknout bez jejího zavírání.

import { useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { useWorkspaceStore } from "../store/workspaceStore";
import { ThemeToggle } from "../components/ThemeToggle";

export function WorkspaceJoinScreen() {
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const join = useWorkspaceStore((s) => s.join);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setError(null);
    try {
      await join(trimmed);
    } catch (err: any) {
      setError(err?.message ?? "Nesprávný kód");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div className="ck scenebg" style={{ height: "100%" }}>
          <ThemeToggle float />
          <form className="lg" onSubmit={handleSubmit}>
            <div className="wordmark">ROUTERA <em>DRIVER</em></div>
            <div className="sub">C.I.T Lama</div>

            <input
              className="wsfield"
              value={code}
              onChange={(e) => {
                setCode(e.target.value.toUpperCase());
                setError(null);
              }}
              placeholder="Kód pracoviště"
              autoFocus
              disabled={submitting}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="characters"
              spellCheck={false}
              style={error ? { borderColor: "var(--bad)" } : undefined}
            />
            <div className="wsgo">
              <button
                type="submit"
                className={`cta${submitting || !code.trim() ? " locked" : ""}`}
                disabled={submitting || !code.trim()}
              >
                {submitting ? "Ověřuji…" : "Připojit se"}
              </button>
            </div>
            <div className="login-err" role={error ? "alert" : undefined} style={{ marginTop: 12 }}>
              {error ?? ""}
            </div>
          </form>
        </div>
      </IonContent>
    </IonPage>
  );
}
